<template>
  <a :href="'/posts/' + post.id" class="post">
    <div class="postHeader" :style="'background-image: url(' + thumbnail + ');background-position: top;background-color: #ffffff;'">
    </div>
    <div class="postFooter">
      <h2 class="postTitle">{{ post.title }}</h2>
      <div class="postExcerpt">{{ post.excerpt }}</div>
      <div class="postFooterFooter">
        <p class="postDate"><i class="material-icons">access_time</i> {{ post.published_at.substring(0, 10) }}</p>
        <p class="postAuthor" v-if="post.source"><i class="material-icons">rss_feed</i> {{ post.source.name }}</p>
      </div>
    </div>
  </a>
</template>

<script>
  export default {
    props: [
      'post',
      'thumbnail',
    ],
  }
</script>

<style lang="scss" scoped>
  @import '../../sass/variables';

  // Medium ~
  @media (min-width:751px){
    .post{margin:0 10px 20px; color: $cText; background: white; cursor: pointer;
      &:link,
      &:visited{ color:$cText;}
      &Header{position:relative;height:calc(100vw / 5 - 10px * 2);background-size: 100% auto;
          &::after{@include anime;content: ""; display: block; width: 100%; height: 100%; background: none;}
      }
      &Footer{height:150px;padding:20px;
          &Footer{display:flex;}
      }
      &Category,
      &Viewed{position:absolute;top:0;font-size: 1rem;}
      &Category{left:0;padding: 5px 20px;color:white;background: none;}
      &Viewed{right:0;padding: 5px 15px; color: white;
        b{margin-right:2px;font-size: 1.1rem;}
      }
      .tags{position:absolute;bottom:10px; padding: 0 10px;}
      &Title{align-items: flex-start; overflow: hidden; max-height: 3.2em; margin-bottom: 5px; font-size: 20px;}
      &Date,
      &Author{@include centerY; margin-right: 20px; font-size: 1rem; line-height: 1; color: cText(40);
        i{margin-right: 3px; font-size: 1.4rem;}
      }
      &:hover{opacity:.85;
        .postHeader::after{background: cBaseDk(0);}
      }
    }
  }
  // Small
  @media screen and (max-width:750px){
    .post{padding: 10px 0; color: $cText; cursor: pointer;
      &:link,
      &:visited{ color:$cText;}
      &Header{position:relative;height:150px;background-size:100% auto;height: calc((100vw - 20px) * 0.35 * 0.6);background-position: center !important;background-color:#EFEFEF !important;
          &::after{@include anime;content: ""; display: block; width: 100%; height: 100%; background: none;}
      }
      &Footer{padding-left:20px;width:65%;
          &Footer{display:flex;}
      }
      &Category,
      &Viewed{position:absolute;top:0;font-size: 1rem;}
      &Category{left:0;padding: 5px 20px;color:white;background: none;}
      &Viewed{right:0;padding: 5px 15px; color: white;
        b{margin-right:2px;font-size: 1.1rem;}
      }
      .tags{position:absolute;bottom:10px; padding: 0 10px;}
      &Title{align-items: flex-start; overflow: hidden; max-height: 3em; margin-bottom: 20px; font-weight: bold;}
      &Date,
      &Author{@include centerY; margin-right: 20px; font-size: 1rem; line-height: 1; color: cText(40);
        i{margin-right: 3px; font-size: 1.4rem;}
      }
      &:hover{opacity:.85;
        .postHeader::after{background: cBaseDk(0);}
      }
    }
  }
  </style>
